import { render, staticRenderFns } from "./custNumChart.vue?vue&type=template&id=5dcb0f1e&"
import script from "./custNumChart.vue?vue&type=script&lang=js&"
export * from "./custNumChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports